export const Navigation = {
  HomePage: {
    href: '/',
    description:
      'Nulla ac ultrices turpis. Duis scelerisque, nulla elementum dignissim dignissim, nisi libero consequat ipsum, ultricies dictum nisi dui ut nunc. Sed aliquet leo quis gravida pulvinar.',
  },
  Dashboard: {
    href: '/dashboard',
    title: 'Dashboard - Sketchnote',
    description:
      'The all-in-one space for startups and entrepreneurs to learn, create, and collaborate with teammates as you scale your organization',
  },
  Signin: {
    href: '/signin',
    description:
      'fermentum dolor eu, vulputate ante. Duis lacinia sit amet ante ac porttitor. Vivamus urna risus, consequat at nunc in, consectetur rhoncus dolor. Aliquam rhoncus ligula ut',
  },
  Signup: {
    href: '/signup',
    description:
      'fermentum dolor eu, vulputate ante. Duis lacinia sit amet ante ac porttitor. Vivamus urna risus, consequat at nunc in, consectetur rhoncus dolor. Aliquam rhoncus ligula ut',
  },
  MyLessons: {
    href: '/my-lessons',
    description:
      'sum primis in faucibus. Sed tristique ligula in purus pretium tincidunt. Nunc ac arcu a risus pulvinar semper a vel neque. Nulla mattis aliquam lacus sed tempor. Curabitur at velit sit amet massa efficitur hendrerit eget a urna. Nullam euismod mauris sed ipsum vehicula, eu pe',
  },
  Catalogue: {
    href: '/catalog',
    description:
      'sum primis in faucibus. Sed tristique ligula in purus pretium tincidunt. Nunc ac arcu a risus pulvinar semper a vel neque. Nulla mattis aliquam lacus sed tempor. Curabitur at velit sit amet massa efficitur hendrerit eget a urna. Nullam euismod mauris sed ipsum vehicula, eu pe',
  },
  GettingStarted: {
    href: '/signup/getting-started',
    description:
      'sum primis in faucibus. Sed tristique ligula in purus pretium tincidunt. Nunc ac arcu a risus pulvinar semper a vel neque. Nulla mattis aliquam lacus sed tempor. Curabitur at velit sit amet massa efficitur hendrerit eget a urna. Nullam euismod mauris sed ipsum vehicula, eu pe',
  },
  InviteUsers: {
    href: '/signup/invite-users',
    description:
      'sum primis in faucibus. Sed tristique ligula in purus pretium tincidunt. Nunc ac arcu a risus pulvinar semper a vel neque. Nulla mattis aliquam lacus sed tempor. Curabitur at velit sit amet massa efficitur hendrerit eget a urna. Nullam euismod mauris sed ipsum vehicula, eu pe',
  },
  SigningUserInfo: {
    href: '/signup/user-info',
    description:
      'sum primis in faucibus. Sed tristique ligula in purus pretium tincidunt. Nunc ac arcu a risus pulvinar semper a vel neque. Nulla mattis aliquam lacus sed tempor. Curabitur at velit sit amet massa efficitur hendrerit eget a urna. Nullam euismod mauris sed ipsum vehicula, eu pe',
  },
  ForgotPassword: {
    href: '/forgot-password',
    description:
      'sum primis in faucibus. Sed tristique ligula in purus pretium tincidunt. Nunc ac arcu a risus pulvinar semper a vel neque. Nulla mattis aliquam lacus sed tempor. Curabitur at velit sit amet massa efficitur hendrerit eget a urna. Nullam euismod mauris sed ipsum vehicula, eu pe',
  },
};
